import { useSearchParams } from "react-router-dom";
import { useAuthStore } from "@/store/auth";
import { PageHeader, Tabs } from "../components/ui";
import { MyTodoSection } from "../advisor/MyTodoPage";
import { GlobalKpiSection } from "./GlobalKpiPage";
import { AiSheetSection } from "../aisheet/AiSheetPage";
import { ContractorAnalysisSection } from "@/features/contractor_led/pages/ContractorAnalysisPage";

export type ProcessControlTab = "todo" | "kpi" | "arkusz-ai" | "podwykonawcy";
const PROCESS_TABS: ProcessControlTab[] = ["todo", "kpi", "arkusz-ai", "podwykonawcy"];

/* „Kontrola procesu" — Moje TODO, Zadania KPI i Arkusz AI (dawniej trzy pozycje
   lewego menu) w jednej stronie z zakładkami. Arkusz AI widzi tylko dyr. techniczny
   i CEO (backend wymusza IsTechnicalDirector) — pozostałym zakładka się nie pokazuje,
   a ?tab=arkusz-ai spada na TODO. Stare adresy /moje-todo, /kpi, /arkusz-ai
   przekierowują tutaj; /kpi/analiza zostaje osobną stroną. */
export function ProcessControlPage() {
  const user = useAuthStore((s) => s.user);
  const canSeeAiSheet = !!user && (user.is_ceo || !!user.is_technical_director);
  const [params, setParams] = useSearchParams();
  const raw = params.get("tab");
  let tab: ProcessControlTab = PROCESS_TABS.includes(raw as ProcessControlTab)
    ? (raw as ProcessControlTab)
    : "todo";
  if ((tab === "arkusz-ai" || tab === "podwykonawcy") && !canSeeAiSheet) tab = "todo";
  const setTab = (k: ProcessControlTab) =>
    setParams(k === "todo" ? {} : { tab: k }, { replace: true });

  return (
    <div className="space-y-4">
      <PageHeader
        title="Kontrola procesu"
        subtitle="Moje TODO, zadania z przeglądów KPI i arkusz analityczny — wszystkie projekty ZE łącznie · DLC_01"
      />

      <Tabs
        tabs={[
          { key: "todo" as const, label: "Moje TODO" },
          { key: "kpi" as const, label: "Zadania KPI" },
          ...(canSeeAiSheet ? [{ key: "arkusz-ai" as const, label: "Arkusz AI" }] : []),
          // Analiza postępów podwykonawcy prowadzącego projekt ZE (apps.contractor_led).
          ...(canSeeAiSheet ? [{ key: "podwykonawcy" as const, label: "Podwykonawcy" }] : []),
        ]}
        active={tab}
        onChange={setTab}
      />

      {tab === "todo" && <MyTodoSection />}
      {tab === "kpi" && <GlobalKpiSection />}
      {tab === "arkusz-ai" && canSeeAiSheet && <AiSheetSection />}
      {tab === "podwykonawcy" && canSeeAiSheet && (
        <div className="space-y-3">
          <h2 className="text-[15px] font-bold">Analiza postępów podwykonawcy</h2>
          <ContractorAnalysisSection />
        </div>
      )}
    </div>
  );
}
